export default __webpack_public_path__ + "static/media/cover.3c9bbc1c.jpg";